export default {
  email: 'Courriel',
  phone: 'Téléphone',
  address: 'Adresse',
};
